import React, { useState, useEffect } from 'react';
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import Footer from './Footer.js';
import { useNavigate, useParams } from 'react-router-dom';
import { BASE_URL, BASE_URL1 } from './Constants.js';
import { Spinner, Alert } from 'react-bootstrap';

const Transfer_Stock = () => {
  const [destinationStock, setDestinationStock] = useState(null);
  const [maxQuantity, setMaxQuantity] = useState(0);
  const [stock, setStock] = useState({
    area: '',
    to_area: '',
    dress_type: '',
    dress_size: '',
    dress_color: '',
    quantity: '',
    gnr_number: '',
    gnr_date: '',
    gnr_image: '',
    gender: '',
    focus_code: '',
    gnr_image_file: null,
  });

  const [areas, setAreas] = useState([]);
  const [dressTypes, setDressTypes] = useState([]);
  const [dressSizes, setDressSizes] = useState([]);
  const [dressColors, setDressColors] = useState([]);
  const [formError, setFormError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const navigate = useNavigate();
  const { id } = useParams();

  // Fetch user profile
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    fetch(`${BASE_URL}profile`, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    })
      .then(res => res.json())
      .then(data => setUser(data.profile.is_uniform_access_given))
      .catch(err => console.error('Profile fetch error:', err));
  }, []);

  const checkDestinationStock = async (toAreaId) => {
    try {
      const token = localStorage.getItem("authToken");

      const response = await fetch(
        `${BASE_URL}check_destination_stock?area_id=${toAreaId}&dress_type=${stock.dress_type}&dress_size=${stock.dress_size}&dress_color=${stock.dress_color}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const result = await response.json();

      if (result.status) {
        setDestinationStock(result.stock);
      } else {
        setDestinationStock(null);
      }
    } catch (err) {
      console.error(err);
    }
  };

  // Fetch dropdown options
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const fetchOptions = async () => {
      try {
        const [areaRes, typeRes, sizeRes, colorRes] = await Promise.all([
          fetch(`${BASE_URL}areas`, { headers: { Authorization: `Bearer ${token}` } }),
          fetch(`${BASE_URL}dress_types`, { headers: { Authorization: `Bearer ${token}` } }),
          fetch(`${BASE_URL}dress_sizes`, { headers: { Authorization: `Bearer ${token}` } }),
          fetch(`${BASE_URL}dress_colors`, { headers: { Authorization: `Bearer ${token}` } }),
        ]);

        const [areaData, typeData, sizeData, colorData] = await Promise.all([
          areaRes.json(),
          typeRes.json(),
          sizeRes.json(),
          colorRes.json(),
        ]);

        setAreas(areaData.areas || []);
        setDressTypes(typeData.dressTypes || []);
        setDressSizes(sizeData.dressSizes || []);
        setDressColors(colorData.dressColors || []);
      } catch (err) {
        console.error('Dropdown fetch error:', err);
      }
    };

    fetchOptions();
  }, []);

  // Fetch stock details by ID
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    fetch(`${BASE_URL}get_stock/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(data => {
        const stockData = data.stock || {};
        setMaxQuantity(Number(stockData.quantity));
        setStock({
          area: stockData.area_id || '',

          dress_type: stockData.dress_type || '',
          dress_size: stockData.dress_size || '',
          dress_color: stockData.dress_color || '',
          quantity: stockData.quantity || '',
          gnr_date: stockData.created_at || '',
          gender: stockData.gender || '',
          focus_code: stockData.focus_code || '',
          gnr_number: stockData.gnr_number || '',
          gnr_image: data.stock.gnr_image || '',
        });
      })
      .catch(err => console.error('Stock fetch error:', err))
      .finally(() => setLoading(false));
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "quantity") {
      let qty = Number(value);

      if (qty < 1) qty = 1;
      if (qty > maxQuantity) qty = maxQuantity;

      setStock(prev => ({
        ...prev,
        quantity: qty,
      }));

      return;
    }

    setStock(prev => ({
      ...prev,
      [name]: value,
    }));

    if (name === "to_area") {
      checkDestinationStock(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stock.area || !stock.dress_type || !stock.dress_size || !stock.dress_color || !stock.quantity) {
      setFormError('All fields are required.');
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const formData = new FormData();
      const fromArea = areas.find(a => a.id == stock.area);
      const toArea = areas.find(a => a.id == stock.to_area);
      const dresstypename = dressTypes.find(a => a.id == stock.dress_type);
      const dresssizename = dressSizes.find(a => a.id == stock.dress_size);
      const dresscolorname = dressColors.find(a => a.id == stock.dress_color);

      formData.append('stock_id', id);
      formData.append('from_area_id', stock.area);
      formData.append('to_area_id', stock.to_area);
      formData.append('from_area_name', fromArea?.area || "");
      formData.append('to_area_name', toArea?.area || ""); // or use 'to_area' if your backend expects this key
      formData.append('dress_type_id', stock.dress_type);
      formData.append('dress_size_id', stock.dress_size);
      formData.append('dress_color_id', stock.dress_color);
      formData.append('dress_type', dresstypename?.dress_type);
      formData.append('dress_size', dresssizename?.dress_size);
      formData.append('dress_color', dresscolorname?.dress_color);
      formData.append('quantity', stock.quantity);
      formData.append('gnr_number', stock.gnr_number);
      formData.append('gnr_date', stock.gnr_date);
      formData.append('gender', stock.gender);
      formData.append('focus_code', stock.focus_code);


      const response = await fetch(`${BASE_URL}stock_transfer`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      const result = await response.json();

      if (result.status) {
        navigate('/manage_stocks');
      } else {
        setFormError('Failed to update stock.');
      }
    } catch (error) {
      setFormError('Error updating stock.');
    }
  };

  const handleBackClick = () => navigate('/manage_stocks');

  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };

  if (loading) {
    return <div className="text-center mt-5"><Spinner animation="border" variant="primary" /></div>;
  }

  return (
    <div className="page-wrapper">
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div className="page-container" style={{
        marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '300px' : '0',
        transition: 'margin-left 0.3s ease',
      }}>
        <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="col-lg-6 offset-lg-3">
                <div className="card add-user-card">
                  <div className="card-header">
                    <h2>Transfer Stock</h2>
                  </div>
                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      {formError && <div className="alert alert-danger">{formError}</div>}

                      <div className="form-group">
                        <label>From Area</label>
                        <input
                          type="text"
                          className="form-control"
                          value={areas.find(a => a.id == stock.area)?.area || ""}
                          readOnly
                        />
                      </div>

                      <div className="form-group">
                        <label>Transfer To Area</label>
                        <select
                          className="form-control"
                          name="to_area"
                          value={stock.to_area || ""}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select Area</option>
                          {areas
                            .filter(a => a.id != stock.area)
                            .map(a => (
                              <option key={a.id} value={a.id}>
                                {a.area}
                              </option>
                            ))}
                        </select>
                      </div>

                      {destinationStock && (
                        <div className="alert alert-info mt-2">
                          <strong>Destination Stock Available</strong>
                          <br />
                          Quantity : {destinationStock.quantity}
                        </div>
                      )}
                      {stock.to_area && !destinationStock && (
                        <div className="alert alert-warning mt-2">
                          No stock found in selected area. A new stock record will be created.
                        </div>
                      )}

                      <div className="form-group">
                        <label>Dress Type</label>
                        <select className="form-control" name="dress_type" value={stock.dress_type} onChange={handleInputChange} disabled>
                          <option value="">Select Type</option>
                          {dressTypes.map(t => <option key={t.id} value={t.id}>{t.dress_type}</option>)}

                        </select>
                      </div>

                      <div className="form-group">
                        <label>Dress Size</label>
                        <select className="form-control" name="dress_size" value={stock.dress_size} onChange={handleInputChange} disabled>
                          <option value="">Select Size</option>
                          {dressSizes.map(s => <option key={s.id} value={s.id}>{s.dress_size}</option>)}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Dress Color</label>
                        <select className="form-control" name="dress_color" value={stock.dress_color} onChange={handleInputChange} disabled>
                          <option value="">Select Color</option>
                          {dressColors.map(c => <option key={c.id} value={c.id}>{c.dress_color}</option>)}
                        </select>
                      </div>

                      <div className="form-group">
                        <label>Quantity</label>
                        <input
                          type="number"
                          className="form-control"
                          name="quantity"
                          value={stock.quantity}
                          onChange={handleInputChange}
                          min="1"
                          max={maxQuantity}
                        />
                      </div>

                      <div className="d-flex justify-content-between">
                        <button type="submit" className="btn btn-primary">Submit</button>
                        <button type="button" className="btn btn-secondary" onClick={handleBackClick}>Cancel</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default Transfer_Stock;
